import { useCallback, useEffect, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import AngleLeft from '@gef-ui/material-icons/AngleLeft';

import { useDefaultRedirect } from 'app/hooks';
import { joinString } from 'utils/string';

import { getVisibleStateById } from './selectors';
import { setVisibleState } from './slice';

export const useCollapsible = ({ id, initiallyOpen = false }) => {
	const dispatch = useDispatch();
	const visibleState = useSelector((state) => getVisibleStateById(state, id, initiallyOpen));

	useEffect(() => {
		dispatch(setVisibleState({ id, visible: initiallyOpen }));
		// eslint-disable-next-line
	}, []);

	const handleToggle = useCallback(() => {
		dispatch(setVisibleState({ id, visible: !visibleState }));
	}, [dispatch, id, visibleState]);

	return { visible: visibleState, handleToggle };
};

export const useRenderSubheaderTitle = ({ contextUser, pageTitle, backButton, onBack }) => {
	const defaultRedirect = useDefaultRedirect();
	const navigate = useNavigate();
	const { state } = useLocation();

	// todo - refactor Link component - to and state separately now
	const handleBack = useCallback(() => {
		const locationFrom = state?.from;
		if (locationFrom) {
			navigate(-1);
		} else {
			navigate(defaultRedirect);
		}
	}, [navigate, state?.from, defaultRedirect]);

	return useMemo(() => {
		let header;
		if (contextUser || backButton) {
			let headerText;

			if (contextUser) {
				headerText = `${pageTitle} (${joinString(' ', [contextUser?.surname, contextUser?.firstName])})`;
			}

			if (backButton) {
				headerText = pageTitle;
			}

			header = (
				<Stack
					onClick={onBack ? onBack : handleBack}
					sx={{
						cursor: 'pointer',
						alignItems: 'center',
					}}
					direction="row"
				>
					<AngleLeft sx={{ fontSize: 40, color: 'primary.main' }} />
					{headerText}
				</Stack>
			);
		} else {
			header = pageTitle;
		}

		return header;
	}, [contextUser, handleBack, pageTitle, onBack, backButton]);
};
